import posthog from 'posthog-js'

const lang = (process.env.NEXT_PUBLIC_LANG || 'en-us').toLowerCase()

if (lang === 'en-us') {
  const projectKey = process.env.NEXT_PUBLIC_POSTHOG_KEY!

  posthog.init(projectKey, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
    // Session recording is OFF by default to preserve quota.
    // It is enabled selectively in DesktopNav / MobileNav when the
    // homepage_cta_impression event fires, so only experiment participants
    // (users who actually saw the homepage CTA) are recorded.
    disable_session_recording: true,
  })
}
